import { render, staticRenderFns } from "./BackgroundChoice.vue?vue&type=template&id=718e8f1e&scoped=true&"
import script from "./BackgroundChoice.vue?vue&type=script&lang=js&"
export * from "./BackgroundChoice.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundChoice.vue?vue&type=style&index=0&id=718e8f1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718e8f1e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheSelect: require('/web/components/TheSelect.vue').default})
